const DEV = process.env.NODE_ENV === 'development'

export default {
  ezLogin: false,
  useFixtures: true,
  yellowBox: DEV,
  reduxLogging: DEV,
  useReactotron: DEV
};
